import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { getLocaleDateWithTimeCustom } from 'app/utils/appHelpers';

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: 'white',
        border: 'none',
        boxShadow: '5px 5px 5px 5px gray',
        padding: '10px',
        maxWidth: '600px',
        color: 'gray',
        fontWeight: '410',
    },
    [`& .MuiTooltip-arrow`]: {
        color: 'white',
    },
});

const CustomTooltipWithContent = ({ reviewUserInfo, reviewUserPdate, children, ...rest }) => {
    // Gelen verileri diziye çeviriyoruz:
    const infoArray = reviewUserInfo
        ? (typeof reviewUserInfo === 'string'
            ? reviewUserInfo.split(',').map(item => item.trim())
            : reviewUserInfo)
        : [];
    const pdateArray = reviewUserPdate
        ? (typeof reviewUserPdate === 'string'
            ? reviewUserPdate.split(',').map(item => item.trim())
            : reviewUserPdate)
        : [];
    const tooltipContent = (
        <Table style={{ margin: 0, padding: 0, tableLayout: 'auto' }}>
            <TableHead>
                <TableRow>
                    <TableCell
                        style={{
                            width: '90%',
                            fontSize: '12px',
                            paddingBottom: 0,
                            paddingTop: 0,
                            paddingLeft: 5,
                        }}
                    >
                        Bilgi
                    </TableCell>
                    <TableCell
                        style={{
                            width: '10%',
                            fontSize: '12px',
                            paddingBottom: 0,
                            paddingTop: 0,
                            // backgroundColor: '#f5f5f5',
                        }}
                    >
                        Tarih
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {infoArray.map((info, index) => (
                    <TableRow key={index}>
                        <TableCell
                            style={{
                                // border: '1px solid #ccc',
                                padding: '4px',
                                fontSize: '12px',
                            }}
                        >
                            {info}
                        </TableCell>
                        <TableCell
                            style={{
                                // border: '1px solid #ccc',
                                padding: '4px',
                                fontSize: '12px',
                            }}
                        >
                            {pdateArray[index]
                                ? getLocaleDateWithTimeCustom('tr', pdateArray[index])
                                : '-'}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );

    return (
        <CustomTooltip title={tooltipContent} placement="top" arrow {...rest}>
            {children}
        </CustomTooltip>
    );
};

export default CustomTooltipWithContent;
